import { render, staticRenderFns } from "./vertical-ranking.vue?vue&type=template&id=4965da09"
import script from "./vertical-ranking.vue?vue&type=script&lang=js"
export * from "./vertical-ranking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports